import './App.css';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import AppComponent from './components/Main';
// import store from './stores/store';
// import {
// 	Provider
// } from 'react-redux';

ReactDOM.render(
    <AppComponent />,
	document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js